import React, { useState } from 'react'
import { Card, Select } from 'antd'
import GradesHistogram from './GradesHistogram'
import Text from 'antd/es/typography/Text'
import { useParams } from 'react-router'
import { useFetchGradesPerComponentAnalyticsQuery } from '../../../../../../../store/apis/analytics.api'

const GradesHistogramCard = () => {
    const { token } = useParams()
    const { data: analytics, isFetching } = useFetchGradesPerComponentAnalyticsQuery({ token })
    const [selectedComponentIndex, setSelectedComponentIndex] = useState(0)
    const componentOptions = analytics?.all.map((component, index) => ({
        label: component.componentName,
        value: index,
    }))

    return (
        <Card
            title='Final Grades'
            extra={
                <label className='d-flex'>
                    <Text type='secondary' className='d-flex-center mr-4'>
                        Component
                    </Text>
                    <Select
                        options={componentOptions}
                        onChange={value => setSelectedComponentIndex(value)}
                        defaultValue={0}
                        loading={isFetching}
                        popupMatchSelectWidth={false}
                        optionRender={option =>
                            option.data.label === 'total' ? <Text strong>Total</Text> : option.label
                        }
                        showSearch
                        optionFilterProp='label'
                    />
                </label>
            }
        >
            <GradesHistogram token={token} selectedComponentIndex={selectedComponentIndex} />
        </Card>
    )
}

export default GradesHistogramCard
